const get = require('../node/get');

module.exports = {
  readFile : function(path, encoding, cb){
    get.httpGet(path, cb);
  }
};



// WEBPACK FOOTER //
// lib/runtime/platform-bootstrap/browser/fs.js